import { useMemo } from "react";
import { usePlatform } from "../../../providers/PlatformProvider";
import { useCollectionStore } from "../../../store/collectionStore";

export function useTemplateRows(articles) {
  const { layout } = useCollectionStore();
  const { showWebVersion } = usePlatform();

  return useMemo(() => {
    const rows = [];
    const articleRowIndexMap = new Map();

    if (!layout?.template || !articles?.length) {
      return { rows, articleRowIndexMap };
    }

    /* -------- Parse templates once -------- */

    const expandedTemplates = layout.template.map((t) => {
      const base = t.split("-").map(Number);
      return showWebVersion ? [...base, ...base] : base;
    });

    const rowCounts = expandedTemplates.map((row) =>
      row.reduce((a, b) => a + b, 0)
    );

    /* -------- Build rows -------- */

    let index = 0;
    let templateIndex = 0;
    let rowIndex = 0;

    while (index < articles.length) {
      const template = expandedTemplates[templateIndex];
      const take = rowCounts[templateIndex];

      const rowArticles = articles.slice(index, index + take);

      /* map article → row index (used for scrollToIndex) */
      rowArticles.forEach((article) => {
        articleRowIndexMap.set(article.id, rowIndex);
      });

      rows.push({
        id: `row-${rowIndex}`,
        template,
        articles: rowArticles,
      });

      index += take;
      templateIndex = (templateIndex + 1) % expandedTemplates.length;
      rowIndex++;
    }

    return {
      rows,
      articleRowIndexMap,
    };
  }, [articles, layout?.template, showWebVersion]);
}